export const classNamePrefix = 'scm';
export const localStorageName = 'simple-consent-manager';